import { palette, spaces } from '@kimuno/theme';
import { SvgIcon } from '@mui/material';
import { format as formatDate } from 'date-fns';
import { de } from 'date-fns/locale';
import type React from 'react';
import { Trans } from 'react-i18next';
import { useSelector } from 'react-redux';

import { subscriptionDateFormat } from '../../constants';
import { selectPendingSchoolLicence } from '../../reducers/user.selectors';
import getMuiIcon from '../../utils/getMuiIcon';
import CustomMarketingAlert from '../CustomMarketingAlert';

export const SCHOOL_LICENCE_NOTICE_KEY =
	'Your school <0>{{schoolName}}</0> has a school licence starting <1>{{startDate}}</1>. ' +
	'From then on you automatically have access to all materials.';

// Tells a pre-invited teacher why they are still on a free account. It takes
// the upgrade banner's slot and cannot be closed: its job is to stop the
// individual purchase that would later block their school seat.
const SchoolLicenceNotice: React.FC = () => {
	const pendingLicence = useSelector(selectPendingSchoolLicence);

	if (!pendingLicence) {
		return null;
	}

	const startDate = formatDate(new Date(pendingLicence.startsAt), subscriptionDateFormat, {
		locale: de,
	});

	return (
		<CustomMarketingAlert
			isShow
			startIcon={
				<SvgIcon
					component={getMuiIcon('infoCircle')}
					sx={{
						width: 22,
						height: 22,
						fill: palette.info.contrastText,
						marginRight: spaces.sm,
					}}
				/>
			}
			title={
				<Trans
					i18nKey={SCHOOL_LICENCE_NOTICE_KEY}
					values={{ schoolName: pendingLicence.schoolName, startDate }}
					components={[<strong key="0" />, <strong key="1" />]}
				/>
			}
		/>
	);
};

export default SchoolLicenceNotice;
